import React from "react";
import EnhancedQuestion from "./enhanced-question.component";
import EnhancedSuggestedQuestions from "../suggested-questions/enhanced-suggested-questions.component";
import { motion } from "framer-motion";
import "./enhanced-question-wrapper.scss";

/**
 * Enhanced Question Wrapper Component
 * 
 * Container for the initial question view that includes the logo, heading,
 * search component, and suggested questions
 */
const EnhancedQuestionWrapper = () => {
  const logo = require("../../assets/ask-tim-final-logo.jpg");

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.15
      }
    }
  };

  const itemVariants = {
    hidden: { y: 15, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.4 }
    }
  };

  return (
    <motion.div 
      className="enhanced-wrapper-container"
      data-testid="enhanced-wrapper-container"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.div data-testid="header-container" className="header-container" variants={itemVariants}>
        <img src={logo} className="logo-image" alt="Ask Tim Logo" />
        <h1 className="main-heading">How can I help you today?</h1>
        <p className="sub-heading">Bringing WorldCC's knowledge to your fingertips.</p>
        <p className="disclaimer-text">Remember - please don't include any personal or confidential data.</p>
      </motion.div>
      
      <motion.div className="search-container" data-testid="search-container" variants={itemVariants}>
        <EnhancedQuestion type="initial" />
      </motion.div>
      
      <motion.div className="suggestions-container" data-testid="suggestions-container" variants={itemVariants}>
        <EnhancedSuggestedQuestions />
      </motion.div>
    </motion.div>
  );
};

export default EnhancedQuestionWrapper;